export default {
  description: '',
  name: '桶柑果實外觀分級表',
  title: [
    { key: 'level', label: '等級' },
    { key: 'pedicle', label: '果蒂' },
    { key: 'scarPercent', label: '疤痕站果實表面積比例' }
  ],
  data: [
    {
      level: 'A',
      levelNumber: 1,
      pedicle: true,
      scarPercent: {
        min: 0,
        max: 2
      }
    },
    {
      level: 'B',
      levelNumber: 2,
      pedicle: true,
      scarPercent: {
        min: 2,
        max: 5
      }
    },
    {
      level: 'C',
      levelNumber: 3,
      pedicle: true,
      scarPercent: {
        min: 5,
        max: 10
      }
    },
    {
      level: 'D',
      levelNumber: 4,
      pedicle: false,
      scarPercent: {
        min: 10,
        max: Infinity
      }
    }
  ]
}
